import React from 'react'
import { Empty } from "antd";

export default function(){
  return <div className="table-loading">
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  </div>
}